import { deleteRequest, getRequest, postRequest, putRequest } from 'config/Axios/baseConfig';
import {
  CoatingType,
  CoatingTypeResponse,
  CoatingTypeSingleResponse
} from 'Interfaces/ReferenceInterfaces/CoatingTypeInterface';

export const coatingTypeScreenServices = {
  getAllCoatingTypes: (page = 1, pageSize = 10000): Promise<CoatingTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CoatingTypeResponse>(
          `pps/coating-types?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getCoatingTypeById: (id: number): Promise<CoatingTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<CoatingTypeSingleResponse>(`pps/coating-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createCoatingType: (
    coatingTypeData: Partial<CoatingType>
  ): Promise<CoatingTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<CoatingTypeSingleResponse>(
          'pps/coating-types/',
          coatingTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  updateCoatingType: (
    id: number,
    coatingTypeData: Partial<CoatingType>
  ): Promise<CoatingTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<CoatingTypeSingleResponse>(
          `pps/coating-types/${id}/`,
          coatingTypeData
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteCoatingType: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/coating-types/${id}`);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
